import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
export var HudNavigationButton = function (_a) {
    var _b = _a.anchor, anchor = _b === void 0 ? IdTooltipAnchor.BottomLeft : _b, disabled = _a.disabled, icon = _a.icon, id = _a.id, loca = _a.loca, onClick = _a.onClick;
    var button = (React.createElement(ButtonNormalSmall, { className: disabled ? IdStyles.StateLocked : "", onClick: onClick },
        React.createElement("div", { className: "flex flex--guts w100 h100", id: id },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge, isLocked: disabled }))));
    var tooltipLoca = disabled ? IdLoca.floatingText_featureNotAvailableYet : loca;
    return loca ? (React.createElement(TooltipText, { id: tooltipLoca, anchor: anchor, key: icon }, button)) : (button);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/navigation/HudNavigationButton.tsx
// module id = 2270
// module chunks = 3